/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable no-prototype-builtins */
import { IReportTree } from '../../../store/modules/report/i-report';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function findReportInTheTree(obj: any, key: any, val: any): IReportTree[] | [] {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let objects: any = [];
  // eslint-disable-next-line no-restricted-syntax
  for (const i in obj) {
    // eslint-disable-next-line no-continue
    if (!obj.hasOwnProperty(i)) continue;
    if (typeof obj[i] === 'object') {
      objects = objects.concat(findReportInTheTree(obj[i], key, val));
    } else
    // eslint-disable-next-line no-mixed-operators
    if (i === key && obj[i] === val || i === key && val === '') { //
      objects.push(obj);
    } else if (obj[i] === val && key === '') {
      if (objects.lastIndexOf(obj) === -1) {
        objects.push(obj);
      }
    }
  }
  return objects;
}

export default findReportInTheTree;
